"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preferentialCryptoSymbols = void 0;
exports.preferentialCryptoSymbols = [
    {
        name: 'Bitcoin',
        symbol: 'BTC',
    },
    {
        name: 'Ethereum',
        symbol: 'ETH',
    },
    {
        name: 'Tether',
        symbol: 'USDT',
    },
    {
        name: 'USD Coin',
        symbol: 'USDC',
    },
    {
        name: 'BNB',
        symbol: 'BNB',
    },
    {
        name: 'XRP',
        symbol: 'XRP',
    },
    {
        name: 'Binance USD',
        symbol: 'BUSD',
    },
    {
        name: 'Cardano',
        symbol: 'ADA',
    },
    {
        name: 'Solana',
        symbol: 'SOL',
    },
    {
        name: 'Dogecoin',
        symbol: 'DOGE',
    },
];
//# sourceMappingURL=preferential-crypto-symbols.js.map